exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-22dc99aa] .el-form-item__label{text-align:right}.tab-wrap[data-v-22dc99aa]{height:calc(100% - 48px);overflow-y:auto;overflow-x:hidden;padding-right:10px}.tab-wrap>div[data-v-22dc99aa]{height:calc(100% - 56px)}", ""]);

// exports
